import { PureComponent } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import get from 'lodash/get';
import {
  MimeTypeHelper,
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';
import {
  AddCircle,
  Add,
  Edit,
} from '@mui/icons-material';
import defaultMixImage from '../../../../assets/default_mix.png';

class Information extends PureComponent {
  /**
   * When a field is changed
   */
  onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * When the tag field is changed
   */
  onChangeTag = (data) => {
    const {
      onUpdate,
    } = this.props;

    onUpdate(data);
  };

  /**
   * When the company field is changed
   */
  onSetCompany = ({
    id: companyId,
    value: companyName,
  }) => {
    const {
      companyId: currCompanyId,
      tags,
      onUpdate,
    } = this.props;

    const data = !companyId
      ? {
        allLocations: false,
        locations: [],
        locationsData: {
          companies: [],
          locations: [],
        },
        tags: currCompanyId !== companyId
          ? tags.filter(tag => tag.type === 'admin')
          : tags,
      }
      : {};

    onUpdate({
      companyId,
      companyName,
      ...data,
    });
  };

  onDrop = (acceptedFiles) => {
    const file = get(acceptedFiles, '[0]', false);

    if (file) {
      const {
        onUpdate,
        onUploadImage,
      } = this.props;

      const reader = new FileReader();
      reader.onload = () => {
        const fileAsDataURL = reader.result;
        // Save image data to state to show as a preview
        onUpdate({ imageUrl: fileAsDataURL });
      };

      reader.onabort = () => console.error('file reading was aborted');
      reader.onerror = () => console.error('file reading has failed');

      reader.readAsDataURL(file);

      onUploadImage(file);
    }
  };

  render() {
    const {
      name,
      description,
      image: mixImage,
      companyName,
      companyId,
      tags,
      isNew,
      isDuplicate,
      disableInput,
      user,
    } = this.props;

    const canSetCompany = user.sysAdmin;

    return (
      <Grid className="Information" spacing={2} container>
        <Grid size={3}>
          <div className="mix-image">
            <Dropzone
              accept={MimeTypeHelper.images}
              multiple={false}
              onDrop={this.onDrop}
            >
              {({ getRootProps, getInputProps, isDragActive }) => {
                return (
                  <div
                    {...getRootProps()}
                    className={`dropzone ${isDragActive ? 'dropzone--isActive' : ''}`}
                  >
                    <input {...getInputProps()} />

                    {mixImage ? (
                      <img src={mixImage} alt="Mix Preview" />
                    ) : (
                      <img src={defaultMixImage} alt="Mix" />
                    )}

                    {isDragActive ? (
                      <div className="icon-drop">
                        <AddCircle className="icon" />
                      </div>
                    ) : null}

                    <div className="icon-container">
                      {isDragActive ? (
                        <Add className="icon" />
                      ) : (
                        <Edit className="icon" />
                      )}
                    </div>
                  </div>
                );
              }}
            </Dropzone>
          </div>
        </Grid>

        <Grid size={9}>
          <Field
            type="text"
            label="Name"
            name="name"
            placeholder="Name"
            value={name}
            tabIndex={1}
            marginBottom={16}
            onChange={this.onChange}
            disabled={disableInput}
            required
            autoFocus
          />

          {canSetCompany && (
            <div className="mix-company">
              <div className="form-container">
                <Field
                  type="company"
                  label="Company"
                  name="companyName"
                  value={companyName}
                  tabIndex={2}
                  companyProps={{
                    companyId,
                    companyName,
                  }}
                  disabled={disableInput || (!isNew && !isDuplicate)}
                  onChange={this.onSetCompany}
                  required
                />
              </div>
            </div>
          )}
        </Grid>

        <Grid size={12}>
          <Field
            style={{
              height: 100,
            }}
            type="textarea"
            label="Description"
            name="description"
            placeholder="Description"
            value={description}
            tabIndex={4}
            onChange={this.onChange}
            disabled={disableInput}
          />
        </Grid>

        <Grid size={12}>
          <Field
            type="tags"
            label="Tags"
            name="tags"
            tagProps={{
              companyId,
              tags,
              allowTypes: ['client', 'admin'],
              showAs: 'list',
              assign: user.can('mix.assign_tag'),
            }}
            disabled={disableInput}
            onChange={this.onChangeTag}
            tabIndex={5}
          />
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Information);
